import { type Preset, definePreset } from "@pandacss/dev";
import b2bDark from "@zenchef/ds-core/dist/panda/b2b-dark/theme.json";
import b2bLight from "@zenchef/ds-core/dist/panda/b2b-light/theme.json";
import b2c from "@zenchef/ds-core/dist/panda/b2c/theme.json";

import { keyframes } from "./theme/keyframes";
import { recipes, slotRecipes } from "./theme/recipes";
import { conditions } from "./theme/conditions";
import { whiteLabel } from "./theme/tokens/whiteLabel";
import { tokens } from "./theme/tokens/tokens";

type Theme = Preset["theme"];

const createPreset = ({
  defaultTheme,
  otherThemes,
  name,
}: {
  name: string;
  defaultTheme: Theme;
  otherThemes: Record<string, Theme>;
}) => {
  const defaultThemeTokens = defaultTheme?.tokens;

  return definePreset({
    name,
    theme: {
      extend: {
        ...defaultTheme,
        tokens: {
          ...defaultThemeTokens,
          ...tokens,
        },
        recipes,
        slotRecipes,
        keyframes,
      },
    },
    themes: otherThemes,
    conditions,
    staticCss: {
      recipes: {
        aromaButton: [{ loading: ["*"] }], // TODO: investigate why it's not working by itself (APP duplicate it)
        aromaDraggableItem: [{ status: ["*"] }],
        aromaDraggableSignifier: [{ edge: ["*"] }],
      },
    },
  });
};

const preset = createPreset({
  name: "zenchef",
  defaultTheme: b2bLight,
  otherThemes: {
    "b2b-dark": b2bDark,
    "b2b-light": b2bLight,
    b2c,
    whiteLabel,
  },
});

export const presetB2C = createPreset({
  name: "zenchef-b2c",
  defaultTheme: b2c,
  otherThemes: { whiteLabel },
});

export const presetB2B = createPreset({
  defaultTheme: b2bLight,
  name: "zenchef-b2b",
  otherThemes: {
    "b2b-dark": b2bDark,
  },
});

export default preset;
